import { render } from "./UserDataShow.vue?vue&type=template&id=cd80d52c"
import script from "./UserDataShow.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDataShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/UserDataShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd80d52c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd80d52c', __exports__)) {
    api.reload('cd80d52c', __exports__)
  }
  
  module.hot.accept("./UserDataShow.vue?vue&type=template&id=cd80d52c", () => {
    api.rerender('cd80d52c', render)
  })

}


export default __exports__